// extracted by mini-css-extract-plugin
export default {"root":"ScrollableContainer_root__zKeIG","list":"ScrollableContainer_list__wZ0JO"};